export default "__VITE_ASSET__B3QmSHXZ__"